/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { Document } from '../../../models/Document';
import { DocumentType } from '../../../models/DocumentType';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasMissingOpenApiPropertyRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        if(node.getDocumentType() === DocumentType.openapi2) {
            this.requireProperty(node, Constants.PROP_SWAGGER, this.map.apply(this, ));
        } else if(node.getDocumentType() === DocumentType.openapi3) {
            this.requireProperty(node, Constants.PROP_OPENAPI, this.map.apply(this, ));
        } else if(node.getDocumentType() === DocumentType.asyncapi2) {
            this.requireProperty(node, Constants.PROP_ASYNCAPI, this.map.apply(this, ));
        }
    }
}
OasMissingOpenApiPropertyRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.OasMissingOpenApiPropertyRule";
OasMissingOpenApiPropertyRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




